import { Box, FormControl, InputAdornment, InputLabel, OutlinedInput } from "@mui/material";
import FeatherIcon from "feather-icons-react";
import React from "react";
import { useThemeMode } from "../theme";

const SearchBar = ({ callBack }) => {
    const { colours } = useThemeMode();
    const [innerValue, setInnerValue] = React.useState("");

    const handleSearch = event => {
        setInnerValue(event.target.value)
        callBack(event.target.value)
    }

    return (
        <Box
            component="form"
            className="searchbar-updated"
            sx={{ minWidth: {sm: "300px"}}}
            flexGrow={1}
        >
            <FormControl
                fullWidth
                variant="outlined"
                size="small"
            >
                <InputLabel htmlFor="searchbar-input">Search</InputLabel>
                <OutlinedInput
                    id="searchbar-input"
                    type="text"
                    endAdornment={
                        <InputAdornment position="end" sx={{ pointerEvents: "none", color: colours.black }}>
                            <FeatherIcon icon="search" size={20} />
                        </InputAdornment>
                    }
                    label="Search"
                    value={innerValue}
                    onChange={(event) => handleSearch(event)}
                />
            </FormControl>
        </Box>
    )
}

export default SearchBar